<template>
  <div class="upload-box">
    <div class='h100-60 noPage'>
      <progress-bar v-show='showProgressBar' ref='progressBar' :text='progressText' class="upload-progress"></progress-bar>
      <ejs-grid ref='grid' height='calc(100% - 80px)'>
        <e-columns>
          <e-column field="pkgName" :headerText="$t('DeployManagement.pkgName')" width="150" textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
          <e-column field="status" :headerText="$t('Software.td_result')" width='80' textAlign="Center" clipMode='EllipsisWithTooltip'></e-column>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>


<script>
  import ProgressBar from 'vue-simple-progress';
  import { EventBus } from '../../../plugins/eventBus';

  export default {
    name: 'batchUploadDialog',
    components: {
      ProgressBar
    },
    data() {
      return {
        showProgressBar: false,
        progressText: '',
        brokenFlag:0,
        taskId:'',
        batchPkg:[],
        timer:'',
        initData:[],
      }
    },
    methods: {
      eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content});
      },
      setParam(param){
        this.taskId = param.taskId;
        const data = [];
        if(param.pkgList){
          param.pkgList.forEach(item =>{
            data.push({pkgName:item,status:'--'})
          });
        }
        this.initData = data;
        this.$refs.grid.ej2Instances.dataSource = data;
        EventBus.$emit("setChildProps", {status:0});
        this.timer = setInterval(this.qryBatchStatus, 10000);
      },
      qryBatchStatus(){
        if(this.taskId != null && this.taskId != ""){
          this.showProgressBar = true;
          const url = '/lte/ems/packageManager/qryBatchStatus/'+this.taskId;
          this.$axios.get(url).then(response => {
            if(response.data.errorCode == 'SUCCESS'){
              let dataResult = [];
              const result = response.data.resultVal;
              for (let key in result) {
                if(key == 'total' || key == 'progress' ){
                  continue;
                }
                dataResult.push({pkgName: key, status:result[key] ? result[key] : '--'});
              }
              if (dataResult.length == 0){
                this.progressText = this.$t('System.processing');
                this.$refs.grid.ej2Instances.dataSource = this.initData;
              }else{
                this.$refs.grid.ej2Instances.dataSource = dataResult;
              }
              if(result.total && result.progress){
                // 完成进度条
                this.progressText = this.$t('DeployManagement.uploadProgress')+":Total:"+result.total+",Finished:"+result.progress;
              }
              if(result.progress != undefined && result.progress == result.total){
                EventBus.$emit("setChildProps", {status:1});
              }
            }
          });
        }
      },
    },
    destroyed() {
      clearInterval(this.timer);
    },
  };
</script>
